export default '1.7.5';



// WEBPACK FOOTER //
// ./version.js